import DataRooms from './DataRooms';

export default DataRooms;
